<template>
  <transition name="modal-fade">
    <div class="overlay" v-if="mostrar" @click.self="fechar">
      <div class="modal-curricularizadas">
        <!-- Header do Modal -->
        <div class="modal-header">
          <span class="modal-label">Ações Curriculares de Extensão</span>
          <button class="btn-fechar-modal" @click="fechar">
            ×
          </button>
        </div>

        <!-- Corpo do Modal -->
        <div class="modal-corpo">
          <!-- Campo de Busca e Filtros Redondos (Pills) no Modal -->
          <div class="header-filtros-modal">
            <div class="busca-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="icone-busca">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input type="text" v-model="termoBusca" placeholder="Buscar por nome da ação..."
                class="input-busca-modal" />
            </div>

            <div class="filtros-pills">
              <button type="button" class="btn-pill" :class="{ ativo: filtroVagas === 'TODAS' }"
                @click="selecionarFiltroVagas('TODAS')">
                Todas
              </button>
              <button type="button" class="btn-pill" :class="{ ativo: filtroVagas === 'COM_VAGAS' }"
                @click="selecionarFiltroVagas('COM_VAGAS')">
                Com Vagas
              </button>
            </div>
          </div>

          <!-- Loading State -->
          <div v-if="carregando" class="loading-state">
            <div class="spinner"></div>
            <p>Carregando ações curricularizadas...</p>
          </div>

          <!-- Tabela de Ações Curricularizadas -->
          <div v-else class="tabela-container">
            <table class="tabela-acoes" v-if="acoesFiltradas.length > 0">
              <thead>
                <tr>
                  <th>Nome da Ação</th>
                  <th>Curso</th>
                  <th>Local</th>
                  <th>Há vagas</th>
                  <th>Total de Vagas</th>
                  <th class="col-contato">Contato</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in acoesFiltradas" :key="item.id" :class="{ 'sem-vagas': !item.temVagas }">
                  <!-- Nome da Ação -->
                  <td class="col-nome">
                    <span class="nome-acao">{{ item.titulo }}</span>
                  </td>

                  <!-- Curso -->
                  <td class="col-curso">
                    <span class="curso-text">🎓 {{ item.curso || "Não informado" }}</span>
                  </td>

                  <!-- Local -->
                  <td class="col-local">
                    <span class="local-text">📍 {{ item.local || "Não informado" }}</span>
                  </td>

                  <!-- Há vagas -->
                  <td class="col-status">
                    <span class="badge-vagas" :class="item.temVagas ? 'disponivel' : 'indisponivel-badge'
                      ">
                      {{ item.temVagas ? "Sim" : "Não" }}
                    </span>
                  </td>

                  <!-- Total de Vagas -->
                  <td class="col-total">
                    <span v-if="item.temVagas" class="total-vagas-badge">
                      {{ item.totalVagas }}
                      {{ item.totalVagas === 1 ? "vaga" : "vagas" }}
                    </span>
                    <span v-else class="total-vagas-badge zero-vagas">
                      -
                    </span>
                  </td>

                  <!-- Botão de Contato com Coordenador -->
                  <td class="col-contato">
                    <button class="btn-contato" :disabled="!isLogado || !item.temVagas || !item.emailCoordenador
                      " @click="
                        isLogado &&
                        item.temVagas &&
                        item.emailCoordenador &&
                        abrirContato(item)
                        " :title="!isLogado
                          ? 'Você precisa estar autenticado para enviar mensagem ao coordenador'
                          : !item.emailCoordenador
                            ? 'E-mail do coordenador não disponível'
                            : !item.temVagas
                              ? 'Esta ação não está aceitando vagas de curricularização no momento'
                              : 'Enviar mensagem para o coordenador da ação'
                          ">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                      </svg>
                      Fale com o Coordenador
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Padrão Paginação (PaginacaoComponent) -->
            <div class="paginacao-modal-wrapper" v-if="totalPaginas > 1">
              <PaginacaoComponent :totalPaginas="totalPaginas" :paginaAtual="paginaAtual" @mudar-pagina="mudarPagina" />
            </div>

            <!-- Empty State -->
            <div v-else-if="acoesFiltradas.length === 0" class="empty-state">
              <p>Nenhuma ação curricularizada encontrada.</p>
            </div>
          </div>
        </div>


      </div>
    </div>
  </transition>

  <!-- Modal Fale Conosco integrado -->
  <ModalFaleConosco :mostrar="modalFaleConoscoVisivel" :acaoId="acaoSelecionada.id" :tituloAcao="acaoSelecionada.titulo"
    :emailCoordenador="acaoSelecionada.emailCoordenador" @fechar="modalFaleConoscoVisivel = false" />
</template>

<script setup>
import { ref, computed, watch, nextTick } from "vue";
import { useAuthStore } from "@/stores/auth";
import { storeToRefs } from "pinia";
import acaoService from "@/service/acaoService";
import ModalFaleConosco from "@/components/ajuda/ModalFaleConosco.vue";
import PaginacaoComponent from "@/components/common/paginacaoComponent.vue";

const authStore = useAuthStore();
const { isAutenticado, estaRenovando } = storeToRefs(authStore);
const isLogado = computed(() => isAutenticado.value || estaRenovando.value);

const props = defineProps({
  mostrar: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["fechar"]);

const carregando = ref(false);
const termoBusca = ref("");
const acoes = ref([]);
const paginaAtual = ref(0);
const totalPaginas = ref(1);
const tamanhoPagina = ref(10);
const totalElementosBackend = ref(0);
const filtroVagas = ref("TODAS"); // 'TODAS' | 'COM_VAGAS'
const modalFaleConoscoVisivel = ref(false);
const acaoSelecionada = ref({ id: null, titulo: "" });

watch(
  () => props.mostrar,
  (newVal) => {
    if (newVal) {
      termoBusca.value = "";
      paginaAtual.value = 0;
      filtroVagas.value = "TODAS";
      nextTick(() => {
        carregarAcoesCurricularizadas();
      });
    }
  }
);

let debounceTimer = null;

watch(termoBusca, () => {
  if (debounceTimer) clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    paginaAtual.value = 0;
    carregarAcoesCurricularizadas();
  }, 300);
});

function selecionarFiltroVagas(opcao) {
  if (filtroVagas.value === opcao) return;
  filtroVagas.value = opcao;
  paginaAtual.value = 0;
  carregarAcoesCurricularizadas();
}

function mudarPagina(novaPagina) {
  paginaAtual.value = novaPagina;
  carregarAcoesCurricularizadas();
}

function fechar() {
  emit("fechar");
}

function abrirContato(item) {
  if (!isLogado.value || !item.temVagas) return;
  acaoSelecionada.value = {
    id: item.id,
    titulo: item.titulo,
    emailCoordenador: item.emailCoordenador,
  };
  modalFaleConoscoVisivel.value = true;
  emit("fechar");
}

async function carregarAcoesCurricularizadas() {
  carregando.value = true;
  try {
    const isCurricularizadaParam =
      filtroVagas.value === "COM_VAGAS" ? true : null;
    const response = await acaoService.getAcoesCurricularizadas(
      paginaAtual.value,
      tamanhoPagina.value,
      termoBusca.value,
      isCurricularizadaParam
    );

    const listaBruta =
      response?.content ||
      response?.data?.content ||
      response?.data ||
      (Array.isArray(response) ? response : []);
    totalPaginas.value =
      response?.totalPages ?? response?.data?.totalPages ?? 1;
    totalElementosBackend.value =
      response?.totalElements ??
      response?.data?.totalElements ??
      listaBruta.length;

    const acoesUnicas = [];
    const idsVistos = new Set();

    for (const item of listaBruta) {
      if (!item) continue;
      const tituloLimpo = (item.titulo || item.nomeAcao || item.nome || "")
        .replace(/"/g, "")
        .trim();
      const idKey = item.id || item.acaoId;
      const cursoNome =
        item.curso ||
        item.nomeCurso ||
        item.cursoNome ||
        item.unidadeAcademica ||
        item.departamento ||
        item.centro ||
        item.cursoSigla;

      const keyUnica = idKey
        ? `${idKey}_${cursoNome || ""}`
        : `${tituloLimpo}_${cursoNome || ""}`;

      if (idsVistos.has(keyUnica)) continue;
      idsVistos.add(keyUnica);

      const valorCurricular =
        item.isCurricularizada ?? item.curricularizada ?? item.curricularizacao;
      const quant =
        item.quantVagas ??
        item.totalVagas ??
        item.quantidadeVagas ??
        item.vagas ??
        0;

      let temVagasDisponiveis = false;
      if (valorCurricular !== undefined && valorCurricular !== null) {
        temVagasDisponiveis = Boolean(valorCurricular);
      } else if (item.temVagas !== undefined) {
        temVagasDisponiveis = Boolean(item.temVagas);
      } else if (item.temVaga !== undefined) {
        temVagasDisponiveis = Boolean(item.temVaga);
      } else {
        temVagasDisponiveis = quant > 0;
      }

      acoesUnicas.push({
        id: idKey || keyUnica,
        titulo: tituloLimpo || item.titulo,
        curso: cursoNome || "Não informado",
        local:
          item.local ||
          item.localVaga ||
          item.unidadeNome ||
          "Presencial/Remoto",
        temVagas: temVagasDisponiveis,
        totalVagas: quant,
        emailCoordenador: item.emailCoordenador || item.email || "",
      });
    }

    acoes.value = acoesUnicas;
  } catch (error) {
    console.error("Erro ao carregar ações curricularizadas:", error);
  } finally {
    carregando.value = false;
  }
}

const acoesFiltradasTotal = computed(() => {
  return acoes.value;
});

const acoesFiltradas = computed(() => {
  return acoes.value;
});

const temMaisParaCarregar = computed(() => {
  if (ehUltimaPagina.value) return false;
  return acoes.value.length < totalElementosBackend.value;
});
</script>

<style scoped>
.modal-curricularizadas {

  border-radius: 12px;
  width: 1150px;
  max-width: 96vw;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow:
    0 10px 25px -5px hsla(0, 0%, 0%, 0.15),
    0 8px 10px -6px hsla(0, 0%, 0%, 0.1);
}



.modal-corpo {
  background-color: var(--branco);

  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.header-filtros-modal {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.busca-container {
  position: relative;
  flex: 1;
}

.filtros-pills {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.btn-pill {
  padding: 6px 18px;
  border-radius: 20px;
  border: 1px solid var(--cinza-claro);
  background: var(--branco);
  color: var(--cinza-escuro);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-pill:hover {
  background: var(--branco);
  border-color: var(--cinza-medio);
}

.btn-pill.ativo {
  background: var(--roxo-primario);
  color: var(--branco);
  border-color: var(--roxo-primario);
  box-shadow: 0 2px 6px hsla(258, 53%, 28%, 0.25);
}

.icone-busca {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--cinza-medio);
}

.input-busca-modal {
  width: 100%;
  padding: 8px 14px 8px 40px;
  border: 1px solid var(--cinza-claro);
  border-radius: 8px;
  font-size: 0.85rem;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}

.input-busca-modal:focus {
  border-color: var(--roxo-medio);
  box-shadow: 0 0 0 3px hsla(258, 46%, 46%, 0.15);
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  gap: 16px;
  color: var(--cinza-medio);
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--cinza-claro);
  border-top-color: var(--roxo-medio);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.tabela-container {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--cinza-claro);
  border-radius: 8px;
}

.tabela-acoes {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 0.85rem;
}

table th {
  background-color: var(--roxo-primario) !important;
  color: var(--branco) !important;
}

.tabela-acoes th {
  background: var(--branco);
  color: var(--cinza-escuro);
  font-weight: 600;
  padding: 9px 12px;
  border-bottom: 1px solid var(--cinza-claro);
  white-space: nowrap;
}

.tabela-acoes td {
  padding: 9px 12px;
  border-bottom: 1px solid var(--branco);
  color: var(--cinza-escuro);
  vertical-align: middle;
}

.tabela-acoes tbody tr:last-child td {
  border-bottom: none;
}

.tabela-acoes tbody tr:hover {
  background: var(--branco);
}

.tabela-acoes tbody tr.sem-vagas {
  background: var(--branco);
}

.col-nome {
  font-weight: 600;
  color: var(--cinza-escuro);
}

.curso-text {
  color: var(--roxo-primario);
  font-size: 0.85rem;
  font-weight: 500;
}

.local-text {
  color: var(--cinza-escuro);
  font-size: 0.85rem;
}

.indisponivel {
  color: var(--cinza-medio);
  font-weight: 500;
}

.badge-vagas.disponivel {
  background: var(--verde-claro);
  color: var(--verde-escuro);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
  display: inline-block;
}

.badge-vagas.indisponivel-badge {
  background: var(--branco);
  color: var(--cinza-medio);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
  display: inline-block;
}



.total-vagas-badge {
  background: var(--roxo-superficie);
  color: var(--roxo-medio);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
  display: inline-block;
}

.total-vagas-badge.zero-vagas {
  background: var(--branco);
  color: var(--cinza-medio);
}

.col-contato {
  text-align: center;
}

.btn-contato {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-contato:hover:not(:disabled) {
  background: var(--roxo-medio);
}

.btn-contato:disabled {
  background: var(--cinza-claro);
  color: var(--cinza-medio);
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.8;
}

.carregar-mais-wrapper {
  display: flex;
  justify-content: center;
  padding: 16px;
  background: var(--branco);
  border-top: 1px solid var(--cinza-claro);
}

.btn-carregar-mais {
  background: var(--branco);
  border: 1.5px solid var(--roxo-medio);
  color: var(--roxo-medio);
  padding: 8px 24px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-carregar-mais:hover {
  background: var(--roxo-superficie);
  box-shadow: 0 2px 6px hsla(258, 46%, 46%, 0.15);
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: var(--cinza-medio);
}



.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.18s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: opacity;
}

.modal-fade-enter-active .modal-curricularizadas,
.modal-fade-leave-active .modal-curricularizadas {
  transition: transform 0.18s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-from .modal-curricularizadas,
.modal-fade-leave-to .modal-curricularizadas {
  transform: scale(0.96) translateY(-8px);
}
</style>
